import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-order-purch-menu',
  templateUrl: './order-purch-menu.component.html',
  styleUrls: ['./order-purch-menu.component.css']
})
export class OrderPurchMenuComponent implements OnInit {
    orderInternalNo;

    public setting?: Setting;

    public itemsListPurchaseHeads: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.orderInternalNo = this.stateService.getStateParams()['order_internal_no'];
    }

    private async loadSetting() {
        if (!!this.orderInternalNo) {
            this.setting = (await this.datatask.Post(999, { order_internal_no: this.orderInternalNo }))[0];
        }
    }

    private async loadPurchaseHeads() {
        if (!this.setting) return;

        this.itemsListPurchaseHeads = await this.datatask.Post(1000, this.setting);
    }

    private async init() {
        await this.loadSetting();
        this.loadPurchaseHeads();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    order_internal_no: string;
}
